<template>
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs"
         xml:space="preserve"
         x="0" y="0" viewBox="0 0 163.861 163.861"
         style="enable-background:new 0 0 512 512"
         :width="size ? size : 512" :height="size ? size : 512"
         :class="[color]">
        <g xmlns="http://www.w3.org/2000/svg">
            <path d="M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275   c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z" fill="#000000" data-original="#000000" class=""></path>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconPlay",
    props: ['color', 'size'],
}
</script>

<style lang="scss" scoped>
path{fill:white}

.dark{
    path{
        fill:#4a4a5a;
    }
}
</style>
